import Vue from 'vue'
import VueRouter from 'vue-router'
import {getUser} from '../utils/public'
import register from '../views/register.vue'
import updateUser from '../views/updateUser.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/register',
    name: 'register',
    component: register
  },
    {
        path: '/updateUser',
        name: 'updateUser',
        component: updateUser
    },
]

const router = new VueRouter({
  routes
})
router.beforeEach((to,form,next) =>{
    let userInfo =getUser();
    userInfo = userInfo?userInfo:{};
    if(!userInfo.session&&to.path!='/register'){
        next({path:"register",query:to.query});
    }
    else if(userInfo.session&&to.path!='/updateUser'){
        next({path:"updateUser",query:to.query});
    }
    else{
        next(true);
    }
})
export default router
